import type { CategorizationRule, KeywordMapping } from '../types';

export const RULES: CategorizationRule[] = [
  {
    category: "Groceries",
    keywords: [
      "aldi",
      "kroger",
      "walmart grocery",
      "whole foods",
      "wholefds",
      "trader joe",
      "meijer",
      "jewel",
      "mariano",
      "target grocery",
      "costco",
      "sam's club",
      "sams club",
      "publix",
      "safeway",
      "food lion",
      "wegmans",
      "heb grocery",
      "caputo",
      "angel caputo",
      "h mart",
      "sprouts",
      "fresh thyme",
      "freshthyme",
      "central market",
      "market basket",
      "stop  shop",
      "giant eagle",
      "fred meyer",
      "qfc",
      "ralphs",
      "food 4 less",
      "winco",
    ],
  },
  {
    category: "Food & Drink",
    keywords: [
      "restaurant",
      "grubhub",
      "doordash",
      "uber eats",
      "postmates",
      "seamless",
      "instacart",
      "gopuff",
      "dunkin",
      "taco bell",
      "arbys",
      "panda express",
      "baked apple",
      "starbucks",
      "mcdonald",
      "mcdonalds",
      "burger king",
      "burger",
      "wendys",
      "five guys",
      "shake shack",
      "in n out",
      "in-n-out",
      "pizza hut",
      "dominos",
      "papa johns",
      "little caesars",
      "pizza",
      "pizzeria",
      "cafe",
      "coffee",
      "chipotle",
      "qdoba",
      "subway",
      "panera",
      "chick fil a",
      "popeyes",
      "kfc",
      "sonic drive",
      "dairy queen",
      "culvers",
      "olive garden",
      "red lobster",
      "applebees",
      "chilis",
      "outback",
      "texas roadhouse",
      "cracker barrel",
      "meal kit",
      "everyplate",
      "hellofresh",
      "blue apron",
      "home chef",
      "tst ",
      "currito",
      "schlotzsky",
      "mcalister",
      "potbelly",
      "tacos",
      "amex dining credit",
      "amex resy credit",
      "ice cream",
      "donut",
      "slice ",
      "baskin",
      "wingstop",
      "jersey mikes",
      "jimmy johns",
      "firehouse subs",
      "whataburger",
      "el pollo loco",
      "del taco",
      "jack in the box",
      "hardees",
      "carls jr",
      "white castle",
      "checkers",
      "rallys",
    ],
  },
];

export const DISPLAY_NAMES: KeywordMapping[] = [
  // Subscriptions moved to shopping.ts
  // Food & Dining
  { keyword: "starbucks", displayName: "Starbucks" },
  { keyword: "mcdonald", displayName: "McDonald's" },
  { keyword: "mcdonalds", displayName: "McDonald's" },
  { keyword: "chipotle", displayName: "Chipotle" },
  { keyword: "dunkin", displayName: "Dunkin'" },
  { keyword: "taco bell", displayName: "Taco Bell" },
  { keyword: "arbys", displayName: "Arby's" },
  { keyword: "panda express", displayName: "Panda Express" },
  { keyword: "burger king", displayName: "Burger King" },
  { keyword: "wendys", displayName: "Wendy's" },
  { keyword: "five guys", displayName: "Five Guys" },
  { keyword: "shake shack", displayName: "Shake Shack" },
  { keyword: "in n out", displayName: "In-N-Out" },
  { keyword: "in-n-out", displayName: "In-N-Out" },
  { keyword: "pizza hut", displayName: "Pizza Hut" },
  { keyword: "dominos", displayName: "Domino's" },
  { keyword: "papa johns", displayName: "Papa John's" },
  { keyword: "panera", displayName: "Panera Bread" },
  { keyword: "chick fil a", displayName: "Chick-fil-A" },
  { keyword: "popeyes", displayName: "Popeyes" },
  { keyword: "kfc", displayName: "KFC" },
  { keyword: "dairy queen", displayName: "Dairy Queen" },
  { keyword: "culvers", displayName: "Culver's" },
  { keyword: "olive garden", displayName: "Olive Garden" },
  { keyword: "red lobster", displayName: "Red Lobster" },
  { keyword: "applebees", displayName: "Applebee's" },
  { keyword: "chilis", displayName: "Chili's" },
  { keyword: "outback", displayName: "Outback Steakhouse" },
  { keyword: "texas roadhouse", displayName: "Texas Roadhouse" },
  { keyword: "cracker barrel", displayName: "Cracker Barrel" },
  { keyword: "everyplate", displayName: "EveryPlate" },
  { keyword: "hellofresh", displayName: "HelloFresh" },
  { keyword: "blue apron", displayName: "Blue Apron" },
  { keyword: "grubhub", displayName: "Grubhub" },
  { keyword: "doordash", displayName: "DoorDash" },
  { keyword: "uber eats", displayName: "Uber Eats" },
  { keyword: "instacart", displayName: "Instacart" },
  { keyword: "wingstop", displayName: "Wingstop" },
  { keyword: "jersey mikes", displayName: "Jersey Mike's" },
  { keyword: "jimmy johns", displayName: "Jimmy John's" },
  { keyword: "firehouse subs", displayName: "Firehouse Subs" },
  { keyword: "whataburger", displayName: "Whataburger" },
  { keyword: "white castle", displayName: "White Castle" },

  // Groceries
  { keyword: "aldi", displayName: "Aldi" },
  { keyword: "costco", displayName: "Costco" },
  { keyword: "walmart", displayName: "Walmart" },
  { keyword: "target", displayName: "Target" },
  { keyword: "kroger", displayName: "Kroger" },
  { keyword: "whole foods", displayName: "Whole Foods" },
  { keyword: "wholefds", displayName: "Whole Foods" },
  { keyword: "trader joe", displayName: "Trader Joe's" },
  { keyword: "jewel", displayName: "Jewel-Osco" },
  { keyword: "mariano", displayName: "Mariano's" },
  { keyword: "sam's club", displayName: "Sam's Club" },
  { keyword: "sams club", displayName: "Sam's Club" },
  { keyword: "publix", displayName: "Publix" },
  { keyword: "safeway", displayName: "Safeway" },
  { keyword: "wegmans", displayName: "Wegmans" },
  { keyword: "meijer", displayName: "Meijer" },
  { keyword: "h mart", displayName: "H Mart" },
  { keyword: "sprouts", displayName: "Sprouts" },
  { keyword: "fresh thyme", displayName: "Fresh Thyme" },
  { keyword: "freshthyme", displayName: "Fresh Thyme" },
  { keyword: "caputo", displayName: "Caputo's" },
  { keyword: "angel caputo", displayName: "Caputo's" },
];
